<!-- Ported from the Polaris kit: src/components/ui/range-calendar/RangeCalendarCellTrigger.vue.
     Classes translated to Tailwind 3 by rebranding_frontend/port-kit-component.mjs.
     Change the design in the kit first, then re-port. -->
<script setup>
import { reactiveOmit } from '@vueuse/core';
import { RangeCalendarCellTrigger, useForwardProps } from 'reka-ui';
import { cn } from '../../lib/utils';
import { buttonVariants } from '../button';

const props = defineProps({
  day: { type: Object, required: true },
  month: { type: Object, required: true },
  asChild: { type: Boolean, required: false },
  as: { type: null, required: false, default: 'button' },
  class: {
    type: [Boolean, null, String, Object, Array],
    required: false,
    skipCheck: true,
  },
});

const delegatedProps = reactiveOmit(props, 'class');

const forwardedProps = useForwardProps(delegatedProps);
</script>

<template>
  <RangeCalendarCellTrigger
    data-slot="range-calendar-trigger"
    :class="
      cn(
        buttonVariants({ variant: 'ghost' }),
        'h-8 w-8 p-0 font-normal data-[selected]:opacity-100',
        '[&[data-today]:not([data-selected])]:bg-polaris-accent [&[data-today]:not([data-selected])]:text-polaris-accent-foreground',
        // Selection Start
        'data-[selection-start]:bg-polaris-primary data-[selection-start]:text-polaris-primary-foreground [&[data-selection-start]:hover]:bg-polaris-primary data-[selection-start]:hover:text-polaris-primary-foreground data-[selection-start]:focus:bg-polaris-primary data-[selection-start]:focus:text-polaris-primary-foreground',
        // Selection End
        'data-[selection-end]:bg-polaris-primary data-[selection-end]:text-polaris-primary-foreground [&[data-selection-end]:hover]:bg-polaris-primary data-[selection-end]:hover:text-polaris-primary-foreground data-[selection-end]:focus:bg-polaris-primary data-[selection-end]:focus:text-polaris-primary-foreground',
        // Outside months
        'data-[outside-view]:text-polaris-muted-foreground',
        // Disabled
        'data-[disabled]:text-polaris-muted-foreground data-[disabled]:opacity-50',
        // Unavailable
        'data-[unavailable]:text-polaris-destructive-foreground data-[unavailable]:line-through',
        props.class
      )
    "
    v-bind="forwardedProps"
  >
    <slot />
  </RangeCalendarCellTrigger>
</template>
